import React from "react";

export default function TermsAndConditions() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">
        Terms & Conditions
      </h1>
      {/* <p className="text-center text-gray-600 mb-8">
        Effective Date: 18 August 2025 <br />
        Website:{" "}
        <a href="https://www.surveysiq.com" className="text-green-600">
          www.surveysiq.com
        </a>
      </p> */}

      <div className="space-y-8 text-gray-700 leading-relaxed">
        {/* 1. Introduction */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            1. Introduction
          </h2>
          <p>
            Welcome to SurveysIQ (“Company”, “we”, “our”, “us”). SurveysIQ is an
            online survey platform that allows users to participate in surveys
            and earn rewards. These Terms and Conditions (“Terms”) govern your
            use of our platform, along with our Privacy Policy.
          </p>
          <p className="mt-2">
            By registering and accessing our Service, you agree that you have
            read, understood, and accepted these Terms. If you do not agree, you
            may not use the Service.
          </p>
        </section>

        {/* 2. Eligibility */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            2. Eligibility
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>You must be at least 18 years old to use the Service.</li>
            <li>
              By using the Service, you confirm that you have the legal capacity
              to enter into this agreement under Indian law.
            </li>
          </ul>
        </section>

        {/* 3. Surveys and Work Rules */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            3. Surveys and Work Rules
          </h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>
              Earnings are based on the number and type of surveys completed and
              the time you spend. No fixed or guaranteed income is promised.
            </li>
            <li>
              If a user is inactive for more than 30 days, or if the user fails
              to earn a minimum of ₹80 in a 30-day period, the account will be
              terminated permanently without prior notice. In such cases, the
              Entry Fee/Security Deposit will be forfeited and converted into
              platform fees.
            </li>
            <li>
              Surveys can include (but are not limited to):
              <ul className="list-disc list-inside ml-6 mt-1">
                <li>Customer Satisfaction Surveys</li>
                <li>Market Research Surveys</li>
                <li>Product Feedback Surveys</li>
                <li>Academic/Educational Surveys</li>
                <li>
                  Open-Ended Surveys, Image Surveys, Quick Surveys, Rating Scale
                  Surveys, and MCQ Surveys
                </li>
              </ul>
            </li>
            <li>
              Advertisements may appear between surveys. Viewing ads is a
              mandatory part of the earning process.
            </li>
            <li>
              Users can potentially earn up to ₹25,000 per month through surveys
              and referrals; however, actual earnings vary and are not
              guaranteed.
            </li>
            <li>
              The Entry Fee is required to access the platform and is considered
              a security deposit, not a subscription fee.
            </li>
            <li>
              If you use an ad-blocker or prevent ads from displaying, you will
              not earn rewards for completed work.
            </li>
            <li>
              If you do not understand any feature, you must contact the support
              team for guidance.
            </li>
            <li>
              Referral earnings:
              <ul className="list-disc list-inside ml-6 mt-1">
                <li>
                  Referral amount can be withdrawn anytime without capping.
                </li>
                <li>To withdraw referral earnings, you must be a paid user.</li>
              </ul>
            </li>
            <li>Only answered survey questions will be eligible for coins.</li>
            <li>
              Any use of third-party software, bots, or malpractice will lead to
              permanent suspension.
            </li>
          </ol>
        </section>

        {/* 4. Communications */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            4. Communications
          </h2>
          <p>
            By using our Service, you agree to receive newsletters, promotional
            content, and other communications. You may unsubscribe at any time
            by following the link or emailing help@surveysiq.com.
          </p>
        </section>

        {/* 5. Purchases & Entry Fee */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            5. Purchases & Entry Fee
          </h2>
          <ol className="list-decimal list-inside space-y-1">
            <li>
              To access SurveysIQ features, users must pay a one-time Entry Fee
              (security deposit).
            </li>
            <li>
              Entry Fee Refund Eligibility:
              <ul className="list-disc list-inside ml-6 mt-1">
                <li>
                  Lite, Standard, and Premium Plan Users: Refund available only
                  if you earn a minimum of ₹35,000 through the platform.
                </li>
                <li>
                  Service Charge: 10% of the Entry Fee will be deducted annually
                  as a maintenance charge.
                </li>
              </ul>
            </li>
            <li>
              Free Trial: May be offered at the Company’s discretion. Billing
              information may be required to activate Free Trial. Unless
              cancelled before expiry, charges will apply after the trial ends.
            </li>
          </ol>
        </section>

        {/* 6. Service Level Agreement (SLA) */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            6. Service Level Agreement (SLA)
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>
              We will make a best-effort attempt to process feedback correctly
              and in a timely manner.
            </li>
            <li>
              However, irrelevant responses or unsupported content are not
              covered under SLA.
            </li>
            <li>
              Services may be temporarily unavailable during maintenance or
              server load issues.
            </li>
          </ul>
        </section>

        {/* 7. Withdrawals & Payments */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            7. Withdrawals & Payments
          </h2>
          <ol className="list-decimal list-inside space-y-1">
            <li>
              Minimum withdrawal: ₹100. Maximum depends on available balance.
            </li>
            <li>
              After completing 100 coins, users must raise a withdrawal request
              in-app.
            </li>
            <li>
              All withdrawals are subject to Indian taxation laws (including
              TDS). Users must declare earnings in their income tax filings.
            </li>
            <li>
              Payments will only be processed through the official withdrawal
              request system.
            </li>
          </ol>
        </section>

        {/* 8. Refunds */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            8. Refunds
          </h2>
          <ol className="list-decimal list-inside space-y-1">
            <li>
              Refunds are discretionary and subject to eligibility conditions.
            </li>
            <li>
              No refunds will be provided in cases of:
              <ul className="list-disc list-inside ml-6 mt-1">
                <li>Account suspension due to inactivity or malpractice</li>
                <li>Voluntary discontinuation by the user</li>
                <li>Partial usage of services</li>
              </ul>
            </li>
            <li>
              Refunds (if eligible) will only be processed via the original
              payment method.
            </li>
            <li>
              The Company reserves the right to utilize the Entry Fee/Security
              Deposit for internal operations but remains liable to refund
              eligible users.
            </li>
          </ol>
        </section>

        {/* 9. Prohibited Uses */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            9. Prohibited Uses
          </h2>
          <p>You must not:</p>
          <ul className="list-disc list-inside ml-6 mt-1 space-y-1">
            <li>Violate Indian laws or international regulations</li>
            <li>Harm or exploit minors</li>
            <li>Send spam, junk mail, or chain letters</li>
            <li>Impersonate the Company, employees, or users</li>
            <li>Infringe intellectual property rights</li>
            <li>Use bots, scripts, or automation to fill surveys</li>
            <li>Hack, disable, or disrupt the Service</li>
            <li>Attempt denial-of-service attacks or spread malware</li>
            <li>Trade, sell, or resell accounts</li>
          </ul>
        </section>

        {/* 10. Accounts */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            10. Accounts
          </h2>
          <ol className="list-decimal list-inside space-y-1">
            <li>
              Accounts must remain active with at least ₹100 monthly earnings.
              Failure will result in suspension.
            </li>
            <li>All accounts remain the property of SurveysIQ.</li>
            <li>
              Users are responsible for keeping login credentials secure. Any
              misuse under your account will be your responsibility.
            </li>
            <li>
              Sharing, reselling, or trading accounts is strictly prohibited.
            </li>
          </ol>
        </section>

        {/* 11. Intellectual Property */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            11. Intellectual Property
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>
              All content, features, design, and software on SurveysIQ remain
              the exclusive property of the Company.
            </li>
            <li>
              Unauthorized copying, redistribution, or modification is
              prohibited.
            </li>
          </ul>
        </section>

        {/* 12. Copyright Policy */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            12. Copyright Policy
          </h2>
          <p>We respect intellectual property rights.</p>
          <ul className="list-disc list-inside ml-6 mt-1 space-y-1">
            <li>
              Copyright complaints must be emailed to help@surveysiq.com with
              the subject “Copyright Infringement”.
            </li>
            <li>
              Complaints must follow the Indian Copyright Act, 1957 with details
              of the work, infringing URL, your ownership proof, and a sworn
              declaration.
            </li>
          </ul>
        </section>

        {/* 13. Analytics & Data */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            13. Analytics & Data
          </h2>
          <p>
            We may use third-party analytics providers to monitor Service usage.
          </p>
        </section>

        {/* 14. Disclaimer of Warranties */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            14. Disclaimer of Warranties
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>
              The Service is provided on an “as is” and “as available” basis.
            </li>
            <li>
              We do not guarantee uninterrupted access, survey availability, or
              fixed earnings.
            </li>
            <li>
              We disclaim all implied warranties, including merchantability and
              fitness for a particular purpose.
            </li>
          </ul>
        </section>

        {/* 15. Limitation of Liability */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            15. Limitation of Liability
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Our liability is limited to the amount of Entry Fee or amount paid
              by the user, whichever is lower.
            </li>
            <li>
              We are not liable for indirect, incidental, or consequential
              damages.
            </li>
          </ul>
        </section>

        {/* 16. Termination */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            16. Termination
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>
              We may suspend or terminate accounts immediately in cases of
              violations.
            </li>
            <li>
              Users may discontinue anytime, but termination does not entitle
              them to refunds unless eligible under the Refund Policy.
            </li>
            <li>
              Provisions relating to ownership, liability, and indemnity survive
              termination.
            </li>
          </ul>
        </section>

        {/* 17. Governing Law */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            17. Governing Law
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>These Terms shall be governed by the laws of India.</li>
            <li>
              Jurisdiction shall rest with the courts of Noida, Uttar Pradesh.
            </li>
          </ul>
        </section>

        {/* 18. Amendments */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            18. Amendments
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>We may update these Terms at any time.</li>
            <li>
              Continued use of the Service implies acceptance of revised Terms.
            </li>
          </ul>
        </section>

        {/* 19. Waiver & Severability */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            19. Waiver & Severability
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Non-enforcement of a clause does not waive our rights.</li>
            <li>
              If any provision is found invalid, the rest will remain
              enforceable.
            </li>
          </ul>
        </section>

        {/* 20. Disclosure */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            20. Disclosure
          </h2>
          <p>
            SurveysIQ will not disclose partner or service provider identities
            to customers under any circumstance.
          </p>
        </section>

        {/* 21. Contact */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            21. Contact
          </h2>
          <p>
            📧 Email:{" "}
            <a href="mailto:help@surveysiq.com" className="text-green-600">
              {" "}
              help@surveysiq.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
